import styled from 'styled-components';
export const Wrapper = styled.div `
  margin: 2.5rem 0 0;
  
  > span {
    display: block;
    margin-bottom: 3rem;
  }
  
  > .h6 {
    font-size: var(--heading-five-font-size);
    letter-spacing: -0.047rem;
    font-weight: 600;
    line-height: 2.4rem;
  }
`;
export const List = styled.ul `
  list-style: none;
  padding: 0;
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
  align-items: stretch;
`;
export const TooltipButton = styled.a `
  padding: 0.5rem;
  border: 0.2rem solid var(--tooltip);
  border-radius: 50%;
  width: 2.4rem;
  height: 2.4rem;
  display: block;
  margin: 0 auto 0.5rem;
  cursor: default;
  line-height: 1.2rem;
  font-weight: 500;
  color: var(--tooltip) !important;
`;
export const Icon = styled.svg `
  fill: white;
  width: 3.5rem;
  height: 3.5rem;
`;
export const ExtrasWrapper = styled.div `
  margin-bottom: 2.1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
`;
export default {
    Wrapper,
    TooltipButton,
};
